import React from 'react';

import { Customer } from '@lumapps/customer/types';
import { Instance } from '@lumapps/instance/types';
import { User } from '@lumapps/user/types';

import { useLumAppsAnalytics } from '../../analytics';
import { usePendo } from '../../hooks/usePendo';

export interface MetricsProps {
    /** If the pendo feature is enabled */
    isPendoEnabled: boolean;
    /** The current customer */
    customer: Customer;
    /** The current instance */
    instance: Instance;
    /** The connected user */
    user?: User;
    /* current user language */
    currentLanguage: string;
    /** whether the user has accepted cookies */
    hasAcceptedCookies: boolean;
    /** whether the user is impersonated */
    isUserImpersonated?: boolean;
}

const UI: React.FC<Omit<MetricsProps, 'isUserImpersonated'>> = ({
    isPendoEnabled = false,
    customer,
    instance,
    user,
    currentLanguage,
    hasAcceptedCookies,
}) => {
    useLumAppsAnalytics();

    // Pendo
    usePendo({
        isPendoEnabled,
        customer,
        instance,
        user,
        currentLanguage,
        hasAcceptedCookies,
    });

    return null;
};

const Metrics: React.FC<MetricsProps> = ({ isUserImpersonated, ...props }) => {
    if (isUserImpersonated) {
        return null;
    }

    return <UI {...props} />;
};

export { Metrics };
